import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { FeatureStatusIcons } from './FeatureMarkers';
import {
  OTC_DELIVERY_KEY,
  isFeatureGeoBlocked,
  isFeatureUsable,
  recordFeatureEvent,
} from '../../utils/productLicensing';
import './features.css';

const FeatureUnavailableCallout = ({
  t,
  entitlement,
  boxId,
  learnMoreTo,
}) => {
  if (!entitlement || isFeatureUsable(entitlement)) {
    return null;
  }

  const geoBlocked = isFeatureGeoBlocked(entitlement);
  const title =
    entitlement.title ||
    t('Assign.NonRxCart.Title', { defaultValue: 'Marketplace Items' });
  const copy = geoBlocked
    ? t('Features.GeoBlockedDetail', {
        defaultValue:
          'This location cannot offer this feature because of local rules.',
      })
    : t('Features.LockedOnScreen', {
        defaultValue:
          'This feature is not available yet. Open Features to learn more or talk to an expert.',
      });
  const detailPath =
    learnMoreTo ||
    `/home/features/${entitlement.feature_key || OTC_DELIVERY_KEY}`;

  return (
    <div className={`otc-feature-callout ${geoBlocked ? 'is-geo' : 'is-locked'}`}>
      <span>
        <span className="otc-feature-callout-title">
          {title}
          <FeatureStatusIcons
            entitlement={entitlement}
            t={t}
            onInfoViewed={() =>
              recordFeatureEvent({
                event: 'feature_tooltip_viewed',
                feature_key: entitlement.feature_key || OTC_DELIVERY_KEY,
                location_id: boxId || undefined,
              })
            }
          />
        </span>
        <p className="otc-feature-callout-copy">{copy}</p>
        <Link to={detailPath} className="otc-feature-callout-link">
          {t('Features.LearnMore', { defaultValue: 'Learn more' })}
        </Link>
      </span>
    </div>
  );
};

FeatureUnavailableCallout.propTypes = {
  t: PropTypes.func.isRequired,
  entitlement: PropTypes.object,
  boxId: PropTypes.string,
  learnMoreTo: PropTypes.string,
};

const OtcDeliveryCallout = (props) => <FeatureUnavailableCallout {...props} />;

OtcDeliveryCallout.propTypes = FeatureUnavailableCallout.propTypes;

export { FeatureUnavailableCallout };
export default OtcDeliveryCallout;



// WEBPACK FOOTER //
// ./src/components/features/OtcDeliveryCallout.js